// ----------------------------------------------------------------------
// <copyright file="Izenda.CacheUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var cacheTimeOut = 3000;
  var AuthUtils = require('share/utils/Izenda.AuthUtils');
  const { constant, uniqueId, identity, get, invoke, cloneDeep } = require('lodash/fp');
  module.exports = {
    /**
     * [memoize description]
     * @method memoize
     * @param  {[type]} func   [description]
     * @param  {Object} option Optional params include:
     *                         resolver : function to get key for cacheTimeOut
     *                         timeOut : timeout value for result to keep in cache after it become fullFill
     *                         persistent : don't time out
     * @return {[type]}        [description]
     */
    memoize: function(func, option) {
      option = option || {};
      var cache = Object.create(null);
      var lastAccessToken = AuthUtils.getAccessToken();
      var resolver = option.resolver || (func.length === 0 ? constant(uniqueId('memoizeCache_')) : identity);
      var persistent = !!get('persistent', option);
      var timeOut = option.timeOut || cacheTimeOut;

      return function() {
        var currentAccessToken = AuthUtils.getAccessToken();
        // reset cache when access token is changed
        if (currentAccessToken !== lastAccessToken) {
          cache = Object.create(null);
          lastAccessToken = currentAccessToken;
        }

        var originalArugment = arguments;
        var key = resolver.apply(this, arguments);
        var resultPromise = cache[key];
        var removeCache = function() {
          delete cache[key];
        };

        if (resultPromise && !invoke('isRejected', resultPromise)) {
          // make new object for both promise and fullFill data
          return resultPromise.then(cloneDeep);
        }

        cache[key] = resultPromise = func.apply(this, originalArugment);

        resultPromise
          .then(function() {
            !persistent && window.setTimeout(removeCache, timeOut);
          })
          .catch(removeCache);

        // make new object for both promise and fullFill data
        return resultPromise.then(cloneDeep);
      };
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.CacheUtils.js